import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class ExportCurrencyRatesProvider extends HttpRequest {
  getItems (query) {
    this.setHeader(getAuthToken())
    return this.get('export-currency-rates', query)
  }

  getItemById (id) {
    this.setHeader(getAuthToken())
    return this.get(`export-currency-rates/${id}`)
  }

  createItem (payload) {
    this.setHeader(getAuthToken())
    return this.post('export-currency-rates', payload)
  }

  updateItem (payload) {
    this.setHeader(getAuthToken())
    return this.put(`export-currency-rates/${payload.id}`, payload)
  }

  updateAllItems (payload) {
    this.setHeader(getAuthToken())

    return this.put('export-currency-rates', payload)
  }

  deleteItem (id) {
    this.setHeader(getAuthToken())
    return this.delete(`export-currency-rates/${id}`)
  }
}

export default ExportCurrencyRatesProvider
